
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// @ts-ignore
import draggable from 'vuedraggable';
import stores from '@/stores';
import { mixin as Clickaway } from 'vue-clickaway';
import { SweetModal } from 'sweet-modal-vue';
import Axios from 'axios';
import TvModule from '@/stores/modules/TvModule';

@Component({
  components: {SweetModal},
  mixins: [ Clickaway ],
})

export default class AddChannelsToCategory extends Vue {
  @Prop()
    module!: TvModule;
  @Prop()
    fullRes!: any;

  searchQuery: string = '';
  indexList: number[] = [];
  allChecked: boolean = false;
  searchInProgress: boolean = false;
  CancelToken: any = Axios.CancelToken;
  source: any;

  search() {
    this.$emit('search', this.searchQuery);
  }

  updateCheck() {
      if (this.indexList.length === this.fullRes.length) {
         this.allChecked = true;
      } else {
         this.allChecked = false;
      }
  }

  save() {
    // @ts-ignore
    this.$emit('save', this.indexList);
  }

  cancel(e: any) {
    e.preventDefault();
    // @ts-ignore
    this.$children[0].close();
  }

}
